import {Component, OnInit, Input} from '@angular/core';
import {DataService} from '../../../../service/data.service';
import { formatFlexibleDateLocale } from '../../../../utils/safe-date.util';

@Component({
    selector: 'app-income-tax-details-v2',
    templateUrl: './income-tax-details-v2.component.html',
    styleUrls: ['./income-tax-details-v2.component.css'],
    standalone: false
})
export class IncomeTaxDetailsV2Component implements OnInit {

  constructor(private dataSource: DataService) {
  }

  @Input() returnData: any;
  @Input() printActive: boolean;
  @Input() inputEnable: boolean;
  isCsrDonation: boolean = false;

  dateWithSign: string
  assessmentYearStart: string

  addIncentive(amount: number | string | null | undefined): number {
    const base = Number(amount ?? 0);
    const incentive = Number(this.returnData?.taxPaymentData?.tc_S_Incentive || 0);
    return (isNaN(base) ? 0 : base) + (isNaN(incentive) ? 0 : incentive);
  }

  reduceIncentive(amount: number | string | null | undefined): number {
    const base = Number(amount ?? 0);
    const incentive = Number(this.returnData?.taxPaymentData?.tc_S_Incentive || 0);
    return (isNaN(base) ? 0 : base) - (isNaN(incentive) ? 0 : incentive);
  }

  ngOnInit(): void {
    this.dataSource.data$.subscribe(data => {
      const currentAssessmentYear = this.returnData.submissionInfo.assessmentYear;
      this.assessmentYearStart = currentAssessmentYear?.split('-')[0];
      this.isCsrDonation = this.returnData?.headSummery?.csrSummary?.csrList?.length;
    })

    this.dateWithSign = formatFlexibleDateLocale(this.returnData && this.returnData.submissionInfo ? this.returnData.submissionInfo.submissionDate : null, 'bn-BD');
  }

}
